import { render, staticRenderFns } from "./buttonPresets.vue?vue&type=template&id=c8a120cc&"
import script from "./buttonPresets.vue?vue&type=script&lang=ts&setup=true&"
export * from "./buttonPresets.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports